export default {
  "备注": "remark",
  "本次发货": "This delivery",
  "本次收货": "Receipt of goods this time",
  "必填": "required",
  "标准": "Standard",
  "标准调拨": "Standard transfer",
  "驳回": "Turn down",
  "驳回数量": "Rejected quantity",
  "驳回数量等于申请数量，请选择审核拒绝": "The number of rejected is equal to the number of applications, please choose to review and reject",
  "不通过": "Not go",
  "仓库名称": "Warehouse name",
  "仓库选择": "Warehouse selection",
  "仓位名称": "Location name",
  "创建": "create",
  "创建区域调拨": "Create an area transfer",
  "创建人": "founder",
  "创建时间": "Creation time",
  "待发货": "Goods waiting to be sent",
  "待收货": "Wait to be received",
  "单位": "unit",
  "地区": "district",
  "地区数据不全": "Regional data is incomplete",
  "的": "the",
  "调拨单": "Transfer slip",
  "调拨单号": "Dialing number",
  "调拨单据": "Transfer document",
  "调拨类型": "Transfer type",
  "调拨申请单": "Application for transfer",
  "调拨审批": "Transfer and approval",
  "调拨详情": "Transfer details",
  "调拨状态": "Allocation state",
  "发货": "Deliver goods",
  "发货方式": "Delivery method",
  "发货信息": "Shipping information",
  "非自提": "Non-pick up",
  "服务商": "Service provider",
  "服务商申请调拨": "Service provider applies for transfer",
  "负责人": "Person in charge",
  "规格型号": "Specification and model",
  "国家/区域": "Country/region",
  "坏": "bad",
  "坏件申请": "Bad parts request",
  "基础信息": "Basic information",
  "仅审批": "Approve only",
  "旧": "The old",
  "旧件申请": "Application for used parts",
  "快递发货": "Express delivery",
  "来源仓库": "Source warehouse",
  "来源仓位": "Source position",
  "联系电话": "Contact number",
  "联系邮箱": "Contact email",
  "目标仓库": "Target warehouse",
  "目标仓库类型不能同时为甲供仓库和常规仓库，请修改": "The target warehouse type cannot be a supply warehouse and a regular warehouse at the same time. Please change it",
  "目标仓位": "Target position",
  "请补充来源信息": "Please add source information",
  "请补充物料": "Please replenish materials",
  "请上传收货凭证，最多可上传6张图片。": "Please upload the receipt voucher, up to 6 pictures can be uploaded.",
  "请上传收货照片": "Please upload the delivery photo",
  "请输入": "Please enter",
  "请输入备注": "Please enter remarks",
  "请输入仓库名称": "Please enter a warehouse name",
  "请输入仓位名称": "Please enter the location name",
  "请输入调拨单号": "Please enter the dial number",
  "请输入调拨申请单": "Please enter the transfer request form",
  "请输入发货快递物流单号": "Please enter the shipping express tracking number",
  "请输入负责人": "Please enter responsible person",
  "请输入企业名称": "Please enter the business name",
  "请输入申请人": "Please enter the applicant",
  "请输入审批单号": "Please enter the approval slip number",
  "请输入审批意见": "Please enter approval comments",
  "请输入物料编码": "Please enter the material code",
  "请输入物料单号": "Please enter BOM number",
  "请输入物料名称": "Please enter the material name",
  "请输入物料名称,物料编码": "Please enter material name, material code",
  "请添加物料": "Please add material",
  "请填写收货电话": "Please fill in the receiving phone number",
  "请填写收货人": "Please fill in the consignee",
  "请填写收货信息": "Please fill in the receiving information",
  "请填写详细地址": "Please fill in the full address",
  "请选择": "Please select",
  "请选择地区": "Please select a region",
  "请选择调拨单": "Please select the dial order",
  "请选择发货方式": "Please select a shipping method",
  "请选择国家/区域": "Please select a country/region",
  "请选择来源仓库": "Please select the source repository",
  "请选择来源仓位": "Please select a source location",
  "请选择目标仓库": "Please select the target warehouse",
  "请选择目标仓位": "Please select a target location",
  "请选择申请企业": "Please select the application enterprise",
  "请选择申请人": "Please select the applicant",
  "请选择审批企业": "Please select the approved enterprise",
  "请选择物料": "Please select material",
  "请选择物料属性": "Please select material properties",
  "区域": "region",
  "区域申请调拨": "Regional request for transfer",
  "全部": "All",
  "全部发货数量不能为0": "The total delivery quantity cannot be 0",
  "全部收货数量不能为0": "The total quantity of goods received cannot be 0",
  "全部物料都已驳回,不可发货": "All materials have been rejected and cannot be shipped",
  "确定": "OK",
  "确认": "verify",
  "确认发货": "Confirm delivery",
  "确认收货": "Confirm receipt of goods",
  "确认物料": "Confirm material",
  "确认要发起申请重试吗?": "Are you sure you want to initiate a retry request?",
  "三方发货单号": "Tripartite invoice number",
  "筛选": "screen",
  "申请": "Apply for",
  "申请/确认发货": "Request/confirm delivery",
  "申请单": "Application form",
  "申请发货": "Apply for delivery",
  "申请企业": "Applicant enterprise",
  "申请人": "applicant",
  "申请数量": "Number of applications",
  "审批": "Examine and approve",
  "审批单号": "Approval number",
  "审批结果": "Examination and approval result",
  "审批企业": "Examining and approving enterprise",
  "审批人": "approver",
  "审批意见": "Approval opinion",
  "是否自提": "Pick-up or not",
  "收货": "Receive goods",
  "收货地区": "Receiving area",
  "收货电话": "Receiving telephone",
  "收货人": "consignee",
  "收货图片": "Receiving picture",
  "收货信息": "Receiving information",
  "收货照片": "Receiving photo",
  "收件人": "addressee",
  "提交": "submit",
  "提交并发货": "Submit and ship",
  "添加收货信息": "Add receiving information",
  "通过": "pass",
  "物料": "materiel",
  "物料编码": "Material code",
  "物料不能为空": "The material must not be empty",
  "物料单号": "Bom number",
  "物料调拨": "Material allocation",
  "物料名称": "Material name",
  "物料清单": "Bill of materials",
  "物料属性": "Material property",
  "物料选择": "Material selection",
  "物流单号": "Logistics tracking number",
  "物流运输": "Logistics transportation",
  "线下取货": "Offline pickup",
  "详细地址": "Detailed address",
  "新": "new",
  "新件申请": "New application",
  "新建成功！": "New success!",
  "新增标准调拨": "New standard allocation",
  "新增服务商申请调拨": "The new service provider applies for transfer",
  "新增区域申请调拨": "The new region applies for allocation",
  "选择调拨单": "Select the transfer order",
  "选择物料": "Select material",
  "已复制": "Copied",
  "已添加": "Have been added",
  "在途": "En route",
  "暂无数据": "No data available",
  "重试": "retry",
  "重置": "reset",
  "自提": "Pick up at home"
}
